import React from 'react';
import { Card, Row, Col, Form, Select, Input } from 'antd';

const { Option } = Select;

export default function ClientInfoSection({
  clients,
  usoCfdiOptions,
  handleClientSelect,
  onSearch
}) {
  const removeRegime = (name) => {
    if (!name) return '';
    // Expresión regular para eliminar regímenes de capital comunes
    return name.replace(/\s+(S\.A\. de C\.V\.|S\.A\.|S\. de R\.L\. de C\.V\.|S\. de R\.L\.|S\.A\.S\.|S\.C\.|A\.C\.|S\.N\.C\.|S\. en N\.C\.|S\. en C\.|S\. en C\. por A\.|Sociedad Anónima|Sociedad Civil|Asociación Civil|S\.A\.P\.I\. de C\.V\.|S\.A\.P\.I\.)\s*$/i, '');
  };

  return (
    <Card title="Información del Cliente" size="small" style={{ marginBottom: '12px' }} styles={{ body: { padding: '12px' } }}>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item
            name="client_id"
            label="Cliente"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Seleccione un cliente' }]}
          >
            <Select
              size="small"
              placeholder="Seleccionar cliente"
              showSearch
              filterOption={false}
              onSearch={onSearch}
              onChange={handleClientSelect}
              notFoundContent={null}
              defaultActiveFirstOption={false}
              showArrow={false}
            >
              {clients.map(client => (
                <Option key={client.id} value={client.id}>
                  {client.tax_id} - {removeRegime(client.tax_name)}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={10}>
          <Form.Item
            name="uso_cfdi"
            label="Uso CFDI"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Seleccione el uso CFDI' }]}
          >
            <Select
              size="small"
              placeholder="Uso CFDI"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children || '').toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {usoCfdiOptions.map(option => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={10}>
          <Form.Item
            name="regimen_fiscal"
            label="Régimen Fiscal"
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Ingrese el régimen fiscal' }]}
          >
            <Input size="small" placeholder="Régimen Fiscal" />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={4}>
          <Form.Item
            name="codigo_postal"
            label="C.P."
            style={{ marginBottom: '8px' }}
            rules={[{ required: true, message: 'Ingrese el código postal' }]}
          >
            <Input size="small" placeholder="C.P." />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}